import React from 'react';
import './ErrorMessageDescription.less';

export const ErrorMessageDescription = ({text}) => {
	return <div className="error-message-description" dangerouslySetInnerHTML={{__html: text}}>
	</div>
}
